<template>
  <div class="inline-block">
    <el-menu-item :index="index" @click="dialogVisible=true">Filtruj</el-menu-item>
    <el-dialog title="Filtry" :visible.sync="dialogVisible" width="600px" center>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row class="center-text">Krowy</el-row>
          <el-checkbox
            v-for="(filter, index) in getCowsFilters()"
            v-bind:key="filter.name"
            v-on:change="onChange(index+1,filter)"
            v-model="filter.selected"
            border
            style="width:100%;"
          >{{filter.name}}</el-checkbox>
        </el-col>
        <el-col :span="12">
          <el-row class="center-text">Jałówki</el-row>
          <el-checkbox
            v-for="(filter, index) in getHeifersFilters()"
            v-bind:key="filter.name"
            v-on:change="onChange(index+8,filter)"
            v-model="filter.selected"
            border
            style="width:100%;"
          >{{filter.name}}</el-checkbox>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button type="primary" @click="dialogVisible = false, applyFilters()">Filtruj</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import bus from "@/bus";
import { serverAddress } from "../config";

export default {
  props: ["index"],
  data: function() {
    return {
      selectedFilters: [],
      filters: [],
      dialogVisible: false
    };
  },
  mounted: function() {
    axios
      .get(serverAddress + "/api/filters", {
        auth: {
          username: "foo",
          password: "bar"
        }
      })
      .then(
        function(response) {
          console.log("filtry ", response.data);

          var filters = response.data;

          this.filters = filters;
        }.bind(this)
      )
      .catch(function(error) {
        console.log(error);
      });
  },
  methods: {
    onChange(index, item) {
      console.log("zmian:", index, item.name, item.selected);

      if (item.selected) {
        this.selectedFilters.push(parseInt(index));
      } else {
        this.selectedFilters = this.selectedFilters.filter(
          item => item !== parseInt(index)
        );
      }

      console.log("selected filters: ", this.selectedFilters);
    },
    getCowsFilters() {
      return Object.values(this.filters).slice(1, 8);
    },
    getHeifersFilters() {
      return Object.values(this.filters).slice(8);
    },
    applyFilters() {
      bus.$emit("apply-filters", this.selectedFilters);
    }
  }
};
</script>

<style scoped>
div.inline-block {
  display: inline-block;
}

.el-checkbox {
  margin-bottom: 5px;
}

.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px;
}

.center-text {
  text-align: center;
}
</style>
